export enum BaseCustomerOfferTabsEnum {
  MaterData,
  AssignmentInformation,
  OfferInformation,
  WorkCouncil,
  Reviews,
  Documents,
  TimeRecordings,
}
